import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule';
import { reportsState, reportsHoursState, reportsLegerState, reportsGrossAllowanceState } from './reports.states';
import { reportsComponent } from './reports.component';
import { reportsHoursComponent } from './reportsHours.component';
import { reportsLegerComponent } from './reportsLeger.component';
import { reportsGrossAllowanceComponent } from './reportsGrossAllowance.component';

const reportsAppModule: aboTheme.INgModule = {
    components: { reportsComponent, reportsHoursComponent, reportsLegerComponent, reportsGrossAllowanceComponent },
    states: [ reportsState, reportsHoursState, reportsLegerState, reportsGrossAllowanceState ],
};

loadNg1Module(ngmodule, reportsAppModule);



// WEBPACK FOOTER //
// ./src/app/modules/reports/index.ts